import { TableCell, TableRow } from '@/components/ui/table';
import { Skeleton } from '@/ui/components/skeleton/skeleton';

export function RolesTableSkeletonRow() {
  return (
    <TableRow>
      <TableCell className="!px-4 py-2">
        <Skeleton className="h-4 w-32" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-4 w-24" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-4 w-32" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-6 w-10" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-6 w-10" />
      </TableCell>
    </TableRow>
  );
}
